import * as React from "react"
import { Text, Theme } from "gatsby-interface"
import CopyUrl from "@modules/ui/components/CopyUrl"

const textCss = (theme: Theme) => ({
  marginTop: 0,
  marginBottom: theme.space[5],
})

export function ManualWebhookIntegrations({ siteId }: { siteId: string }) {
  const webhookLink = `${process.env.GATSBY_WEBHOOK_URL}/hooks/data_source/${siteId}`
  return (
    <div
      css={theme => [
        theme.cardStyles.space.L,
        {
          borderTop: `1px solid ${theme.colors.standardLine}`,
        },
      ]}
    >
      <Text
        size="S"
        css={textCss}
        data-cy="webhook-section-description"
        id="webhook-section-description"
      >
        Not using any of the above? This POST endpoint should be triggered on
        any content change so your Preview is consistent with the state of your
        CMS, automatically!
      </Text>
      <CopyUrl
        url={webhookLink}
        data-cy-name="copy-webhook-url"
        aria-describedby="webhook-section-description"
      />
    </div>
  )
}
